<template>
  <el-container>
    <!-- 标题 -->
    <el-header class="pa-0">
      <el-row class="bg-color-w">
        <el-col :xs="4" :sm="2" :md="2" :lg="1" :xl="1" class="pl-30 pt-10">
          <img src="/img/images/dbsx_icon.png" class="" style="width: 40px" />
        </el-col>
        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="pt-15 pl-5">
          <div class="fs-22">{{ title }}</div>
        </el-col>
      </el-row>
    </el-header>
    <!-- 内容 -->
    <el-main class="content">
      <el-row class="pb-20 menuList" v-if="menuData.length > 1">
        <template v-for="(item, index) in menuData">
          <div
            :key="index"
            :class="
              activeindex == index
                ? 'color-primary br-color-primary bw-b-3 br-b-solid '
                : ''
            "
            class="mx-10 py-10 cursor-p float-l"
            @click="setactiveindex(index)"
          >
            {{ item.qname }}
          </div>
        </template>
      </el-row>
      <el-row class="bg-color-w">
        <router-view :key="getRowKeys()"></router-view>
        <!-- <iframe
          v-else
          ref="iframe"
          :src="url"
          width="100%"
          height="740px"
          frameborder="0"
          @load="iframeLoad()"
          :key="url"
        ></iframe> -->
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import * as yhxx from "@/api/yhxx";

export default {
  name: "qtxt",
  components: {},
  computed: {},
  watch: {
    activeindex: {
      handler: function(newVal, oldVal) {
      },
    },
    "$route.params.title"(val) {
      this.init();
    },
    "$route.name"(val) {
      if (val != "/qtxtIframe") {
        this.toSysUrl();
      }
    },
  },
  data() {
    return {
      tableData: [],
      title: "",
      activeindex: -1,
      activQid: "",
      loading: false,
      menuData: [],
      url: null,
      path: "",
      urlflg: "",
      flg: true,
    };
  },
  methods: {
    getRowKeys() {
      let key = Math.random();
      return key;
    },
    init() {
      console.log("init");
      this.url = this.$route.params.url;
      this.path = this.$route.name;
      this.title = this.$route.params.title;
      this.menuData = this.$route.params.menus;
      this.activeindex = this.$route.params.activeindex;
      if (this.menuData && this.menuData[0] !== "[object Object]") {
        this.$session.setItem("qtxtMenu", JSON.stringify(this.menuData));
      } else {
        this.menuData = JSON.parse(this.$session.getItem("qtxtMenu"));
      }
      if (this.activeindex > -1) {
        this.$session.setItem(
          "qtxtActiveMenu",
          JSON.stringify(this.activeindex)
        );
      } else {
        this.activeindex = JSON.parse(this.$session.getItem("qtxtActiveMenu"));
      }
      if (this.path) {
        this.$session.setItem("activePath", JSON.stringify(this.path));
      } else {
        this.path = JSON.parse(this.$session.getItem("activePath"));
      }
      this.toSysUrl();
    },
    setactiveindex(index) {
      this.activeindex = index;
      this.$session.setItem(
        "qtxtActiveMenu",
        JSON.stringify(this.activeindex)
      );
      this.$router.push({
        name: "/qtxt",
        params: {},
      });
      this.toSysUrl();
    },
    iframeLoad() {
      // debugger;
      window.frames[0].postMessage("测试信息", this.url);
    },
    toSysUrl() {
      let menu = this.menuData[this.activeindex];
      console.log("toSysUrl", menu);
      this.title = menu.qname;
      if (menu) {
        if (menu.urlflg == "0") {
          this.$router.push({
            name: "/" + menu.urllink,
            params: {
              title: this.title,
              activeindex: this.activeindex,
            },
          });
        } else {
          // if (this.activQid != menu.qid) {
          // this.activQid = menu.qid;
          yhxx.getNewPageUrl(menu).then((res) => {
            // debugger;
            let url = res.data.data;
            this.$store.commit("setIframeUrl", url);
            if (menu.urlflg == "1") {
              this.$router.push({
                name: "/qtxtIframe",
                params: {
                  title: this.title,
                  url: url,
                },
              });
            } else if (menu.urlflg == "2") {
              var newwindow = window.open(url);
            }
          });
          // }
        }
      }
    },
  },
  beforeMount() {
    window.addEventListener("message", function(evt) {});
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.content {
  max-height: 100%;
}
.menuList {
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
  display: flex;
}
</style>
